import { Box, Grid, TextField } from "@mui/material";
import * as React from "react";
import { EventEditUrgencyClassField } from "ui/Scripts/source/components/event/EventEditUrgencyClassField/EventEditUrgencyClassField";
import { Dropdown } from "ui/Scripts/source/components/framework/Dropdown/Dropdown";
import { TreeCheckBoxDropdownItems } from "ui/Scripts/source/components/framework/Dropdown/TreeCheckboxDropdown/TreeCheckboxDropdownItems";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";
import { Translations } from "ui/Scripts/source/models/translations";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { IEventEditNew } from "../../../models/event/eventEditNew";
import { EventTypeNode } from "../../../models/eventType/eventTypeNode";
import * as eventService from "../../../models/services/eventService";
import { ISessionState } from "../../../models/session/sessionState";
import { DatePicker } from "../../framework/DateTime/DatePicker";
import { Dialog } from "../../framework/Dialog/Dialog";
import { FormSectionTitle } from "../../framework/Form/FormSectionTitle";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { SelectUnitTree } from "../../framework/Unit/SelectUnitDialog";
import { AvatarName } from "../../framework/User/AvatarName";
import { TimePicker } from "source/components/framework/DateTime";

/* eslint-disable no-unused-vars */
const enum NewEventDialogPage {
    Receiver = "1",
    EventType = "2",
    EventTypeB = "3",
    EventTypeC = "4",
    Basic = "5"
}
/* eslint-enable no-unused-vars */

export interface IEventEditNewEventDialogProp {
    classes?: string;
    sessionState: ISessionState;
    companyId: string;
    onOk: (eventId: string) => void;
    onCancel: () => void;
}

export interface IEventEditNewEventDialogState {
    page: NewEventDialogPage;
    pageIsLastPage: boolean;
    eventEditNew: IEventEditNew;
    urgencyClasses: IIdColorTitle[];
    eventTypeNodes: IIdTitleNode[];
    eventTypeBNodes: IIdTitleNode[];
    eventTypeCNodes: IIdTitleNode[];
    eventSetting: IEventSettingSimple;
    // Receiver
    createCompanyId: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    companyId: string;
    unitId: string;
    unitCode: string;
    handlers: IModifyUser[];
    // Basic
    urgencyClassId: string;
    dateStr: string;
    timeStr: string;
    name: string;
    description: string;
    observerAction: string;
    showSelectCompanyDialog: boolean;
    // EventTypes
    eventTypeIds: string[];
    eventTypeBIds: string[];
    eventTypeCIds: string[];
}

export class EventEditNewEventDialog extends React.Component<IEventEditNewEventDialogProp, IEventEditNewEventDialogState> {
    private orgStateHash: string = "";
    
    getStateFromProps = (props: IEventEditNewEventDialogProp): IEventEditNewEventDialogState => {
        const nowTicks = Base.getNowTicks();
        return {
            page: NewEventDialogPage.Receiver,
            pageIsLastPage: false,
            eventEditNew: null,
            urgencyClasses: [],
            eventTypeNodes: [],
            eventTypeBNodes: [],
            eventTypeCNodes: [],
            eventSetting: null,
            // Receiver
            createCompanyId: props.companyId,
            createCompanyUnitId: "",
            createCompanyUnitCode: "",
            companyId: props.companyId,
            unitId: "",
            unitCode: "",
            handlers: [],
            // Basic
            urgencyClassId: "",
            dateStr: Base.timeToDateStr(nowTicks),
            timeStr: Base.timeToTimeStr(nowTicks),
            name: "",
            description: "",
            observerAction: "",
            showSelectCompanyDialog: false,
            // EventTypes
            eventTypeIds: [],
            eventTypeBIds: [],
            eventTypeCIds: []
        };
    };

    constructor(props: IEventEditNewEventDialogProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveData(this.props, this.state).hash;
    }

    async componentDidMount(): Promise<void> {
        const props = this.props;
        const eventEditNew = await AppUtils.callService(() => eventService.getEventEditNew(props.companyId), false, false);
        if (!eventEditNew) return;
        const companyId = eventEditNew.companies[0].id;
        const unit = IdTitleNode.getFirstActiveNode(eventEditNew.units);
        const result = await AppUtils.callService(() => eventService.getDefaultEventHandlersForUnit(companyId, companyId, unit.id, true));
        if (!result) return;
        for (const handler of result.handlers) {
            handler.date = 0;
        }
        const handlers = ModifyUser.sortModifyUsers(result.handlers, { currentUserCode: props.sessionState.code });
        const stateChange = {
            eventEditNew,
            createCompanyId: companyId,
            companyId,
            unitId: result.unitId,
            unitCode: result.unitCode,
            urgencyClassId: eventEditNew.urgencyClassId,
            createCompanyUnitId: result.unitId,
            createCompanyUnitCode: result.unitCode,
            handlers,
            urgencyClasses: eventEditNew.urgencyClasses,
            eventTypeNodes: EventTypeNode.getAsIdTitleNodes(eventEditNew.eventTypeNodes),
            eventTypeBNodes: EventTypeNode.getAsIdTitleNodes(eventEditNew.eventTypeBNodes),
            eventTypeCNodes: EventTypeNode.getAsIdTitleNodes(eventEditNew.eventTypeCNodes),
            eventSetting: eventEditNew.eventSetting
        };
        this.orgStateHash = this.getSaveData(this.props, { ...this.state, ...stateChange }).hash;
        this.setState(stateChange);
    }
    
    handleMoveToPreviousPage = () => {
        const state = this.state;
        const oldPage = state.page;
        const eventTypesExist = state.eventTypeNodes.length > 0;
        const eventTypeBsExist = state.eventTypeBNodes.length > 0;
        const eventTypeCsExist = state.eventTypeCNodes.length > 0;
        let page = oldPage;
        if (oldPage === NewEventDialogPage.EventType) {
            page = NewEventDialogPage.Receiver;
        } else if (oldPage === NewEventDialogPage.EventTypeB) {
            page = eventTypesExist
                ? NewEventDialogPage.EventType
                : NewEventDialogPage.Receiver;
        } else if (oldPage === NewEventDialogPage.EventTypeC) {
            page = eventTypeBsExist
                ? NewEventDialogPage.EventTypeB
                : (eventTypesExist
                    ? NewEventDialogPage.EventType
                    : NewEventDialogPage.Receiver);
        } else if (oldPage === NewEventDialogPage.Basic) {
            page = eventTypeCsExist
                ? NewEventDialogPage.EventTypeC
                : (eventTypeBsExist
                    ? NewEventDialogPage.EventTypeB
                    : (eventTypesExist
                        ? NewEventDialogPage.EventType
                        : NewEventDialogPage.Receiver));
        }
        this.setState({
            page,
            pageIsLastPage: false
        });
    };
    
    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (!state.dateStr) {
                AppUtils.showErrorMessage(Translations.DateMustBeDefined);
                return resolve(false);
            }
            if (!state.timeStr) {
                AppUtils.showErrorMessage(Translations.TimeMustBeDefined);
                return resolve(false);
            }
            if (!state.name) {
                AppUtils.showErrorMessage(Translations.TitleMustBeDefined);
                return resolve(false);
            }
            if (!state.description) {
                AppUtils.showErrorMessage(Translations.DescriptionMustBeDefined);
                return resolve(false);
            }
            if (state.eventSetting.observerActionIsRequired() && !state.observerAction) {
                AppUtils.showErrorMessage(Translations.ObserverActionMustBeDefined);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    handleMoveToNextPage = async () => {
        const state = this.state;
        const oldPage = state.page;
        const eventTypesExist = state.eventTypeNodes.length > 0;
        const eventTypeBsExist = state.eventTypeBNodes.length > 0;
        const eventTypeCsExist = state.eventTypeCNodes.length > 0;
        if (oldPage === NewEventDialogPage.Basic) {
            if (!await AppUtils.validate(this.checkErrors)) return;
        }
        let page = oldPage;
        if (oldPage === NewEventDialogPage.Receiver) {
            page = eventTypesExist
                ? NewEventDialogPage.EventType
                : (eventTypeBsExist
                    ? NewEventDialogPage.EventTypeB
                    : (eventTypeCsExist
                        ? NewEventDialogPage.EventTypeC
                        : NewEventDialogPage.Basic));
        } else if (oldPage === NewEventDialogPage.EventType) {
            page = eventTypeBsExist
                ? NewEventDialogPage.EventTypeB
                : (eventTypeCsExist
                    ? NewEventDialogPage.EventTypeC
                    : NewEventDialogPage.Basic);
        } else if (oldPage === NewEventDialogPage.EventTypeB) {
            page = eventTypeCsExist
                ? NewEventDialogPage.EventTypeC
                : NewEventDialogPage.Basic;
        } else if (oldPage === NewEventDialogPage.EventTypeC) {
            page = NewEventDialogPage.Basic;
        }
        this.setState({
            page,
            pageIsLastPage: page === NewEventDialogPage.Basic
        });
    };

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        // Basic
        if (name === "name") {
            this.setState({ name: value });
        } else if (name === "description") {
            this.setState({ description: value });
        } else if (name === "observerAction") {
            this.setState({ observerAction: value });
        }
    };

    handleChangeEventTypeIds = (ids: string[]) => {
        this.setState({ eventTypeIds: ids });
    };

    handleChangeEventTypeBIds = (ids: string[]) => {
        this.setState({ eventTypeBIds: ids });
    };

    handleChangeEventTypeCIds = (ids: string[]) => {
        this.setState({ eventTypeCIds: ids });
    };

    // #region Company
    handleCompanyChange = async (companyId: string) => {
        const state = this.state;
        const activeCompanyIsSendingCompany = companyId === state.createCompanyId;
        const result = await AppUtils.callService(() => eventService.getDefaultEventHandlersForUnit(companyId, state.createCompanyId, activeCompanyIsSendingCompany ? state.createCompanyUnitId : null, true));
        if (!result) return null;
        for (const handler of result.handlers) {
            handler.date = 0;
        }
        const handlers = ModifyUser.sortModifyUsers(result.handlers, { currentUserCode: this.props.sessionState.code });
        this.setState({
            companyId,
            unitId: result.unitId,
            unitCode: result.unitCode,
            createCompanyUnitId: activeCompanyIsSendingCompany ? result.unitId : state.createCompanyUnitId,
            createCompanyUnitCode: activeCompanyIsSendingCompany ? result.unitCode : state.createCompanyUnitCode,
            handlers,
            eventSetting: result.eventSetting
        });
    };
    // #endregion Company

    // #region Select Unit
    handleSelectUnit = async (selectedId: string) => {
        const props = this.props;
        const state = this.state;
        if (!selectedId) return;
        const node = IdTitleNode.getById(state.eventEditNew.units.filter(i => i.id !== Base.emptyGuid), selectedId);
        if (!node) return;
        const activeCompanyIsReceivingCompany = props.companyId === state.companyId;
        const activeCompanyIsSendingCompany = props.companyId === state.createCompanyId;
        if (activeCompanyIsReceivingCompany) {
            const result = await AppUtils.callService(() => eventService.getDefaultEventHandlersForUnit(state.companyId, state.createCompanyId, node.id, true));
            if (!result) return null;
            for (const handler of result.handlers) {
                handler.date = 0;
            }
            const handlers = ModifyUser.sortModifyUsers(result.handlers, { currentUserCode: props.sessionState.code });
            this.setState({
                unitId: result.unitId,
                unitCode: result.unitCode,
                createCompanyUnitId: activeCompanyIsSendingCompany ? result.unitId : state.createCompanyUnitId,
                createCompanyUnitCode: activeCompanyIsSendingCompany ? result.unitCode : state.createCompanyUnitCode,
                handlers
            });
        } else {
            this.setState({
                createCompanyUnitId: node.id,
                createCompanyUnitCode: node.title
            });
        }
    };
    
    // #endregion Select Unit
    getSaveData = (props: IEventEditNewEventDialogProp, state: IEventEditNewEventDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("activeCompanyId", props.companyId);
        result.append("companyId", state.companyId);
        result.append("unitId", state.unitId);
        result.append("urgencyClassId", state.urgencyClassId);
        result.append("createCompanyId", state.createCompanyId);
        result.append("createCompanyUnitId", state.createCompanyUnitId);
        result.append("date", Base.getDateTime(state.dateStr, state.timeStr).getTime());
        result.append("name", state.name);
        result.append("description", state.description);
        result.append("observerAction", state.observerAction);
        result.append("eventTypeIds", state.eventTypeIds);
        result.append("eventTypeBIds", state.eventTypeBIds);
        result.append("eventTypeCIds", state.eventTypeCIds);
        result.append("handlers", state.handlers.map(i => i.code));
        return result;
    };

    handleSave = async () => {
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors)) return null;
        // Set data
        const saveData = this.getSaveData(this.props, state);
        // Call server
        const result = await AppUtils.callService(() => eventService.saveEventEditNew(saveData.obj));
        if (!result) return null;
        this.orgStateHash = this.getSaveData(this.props, state).hash;
        if (result) {
            this.props.onOk(result.id);
        }
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveData(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.handleSave();
        } else {
            props.onCancel();
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.eventEditNew) return null;
        const eventEditNew = state.eventEditNew;
        const activeCompanyIsReceivingCompany = props.companyId === state.companyId;
        const receiverCompany = eventEditNew.companies.find(i => i.id === state.companyId);
        return (
            <Dialog
                id="event-edit-new-event-dialog"
                maxWidth="sm"
                title={Translations.AddEvent}
                body={
                    <>
                        {state.page === NewEventDialogPage.Receiver &&
                            <>
                                <GridRow>
                                    <Grid item xs>
                                        <FormSectionTitle margin={0}>{Translations.SelectEventReceiver}</FormSectionTitle>
                                    </Grid>
                                </GridRow>
                                {eventEditNew.companies.length > 1 &&
                                    <GridRow>
                                        <Grid item xs>
                                            <FormField title={Translations.Company} margin={0}>
                                                <Dropdown
                                                    classes="withAvatar"
                                                    selectedTitle={<AvatarName
                                                        name={receiverCompany.name}
                                                        picture={receiverCompany.logo}
                                                    />}
                                                    selectMode={true}
                                                    actions={eventEditNew.companies.map((company) => {
                                                        return {
                                                            title: <AvatarName
                                                                name={company.name}
                                                                picture={company.logo}
                                                            />,
                                                            textTitle: company.name,
                                                            selected: company.id === state.companyId,
                                                            onClick: () => this.handleCompanyChange(company.id)
                                                        };
                                                    })}
                                                />
                                            </FormField>
                                        </Grid>
                                    </GridRow>
                                }
                                {activeCompanyIsReceivingCompany &&
                                    <React.Fragment>
                                        <GridRow>
                                            <Grid item xs sx={{ marginTop: eventEditNew.companies.length > 1 ? "1.5rem" : "1rem" }}>
                                                <EventEditUrgencyClassField
                                                    urgencyClasses={state.urgencyClasses}
                                                    urgencyClassId={state.urgencyClassId}
                                                    onChange={(urgencyClassId) => this.setState({ urgencyClassId })}
                                                />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item xs>
                                                <FormField title={Translations.Unit}>
                                                    <Box sx={{
                                                        maxHeight: "calc(100vh - 456px)",
                                                        overflowY: "auto",
                                                    }}>
                                                        <SelectUnitTree
                                                            nodes={eventEditNew.units.filter(i => i.id !== Base.emptyGuid)}
                                                            firstColumnTitle={Translations.Unit}
                                                            selectedId={state.unitId}
                                                            margin={0}
                                                            onClick={this.handleSelectUnit}
                                                        />
                                                    </Box>
                                                </FormField>
                                            </Grid>
                                        </GridRow>
                                    </React.Fragment>
                                }
                            </>
                        }
                        {state.page === NewEventDialogPage.Basic &&
                            <>
                                <GridRow>
                                    <Grid item xs>
                                        <FormSectionTitle margin={0}>{Translations.Event}</FormSectionTitle>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item sm={6}>
                                        <FormField title={Translations.Date} required margin={0}>
                                            <DatePicker
                                                value={state.dateStr}
                                                onChange={(value: string) => this.setState({ dateStr: value })}
                                            />
                                        </FormField>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <FormField title={Translations.Time} required margin={0}>
                                            <TimePicker
                                                value={state.timeStr}
                                                onChange={(timeStr: string) => this.setState({ timeStr })}
                                            />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item xs>
                                        <FormField title={Translations.Title} required>
                                            <TextField type="text" name="name" title={Translations.Title} inputProps={{ maxLength: 100 }} value={state.name} onChange={this.handleChange} />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item xs>
                                        <FormField title={Translations.Description} required>
                                            <TextField name="description" title={Translations.Description} inputProps={{ maxLength: 10000 }} multiline minRows={5} value={state.description} onChange={this.handleChange} />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                                {state.eventSetting.observerActionIsInUse() &&
                                    <GridRow>
                                        <Grid item xs>
                                            <FormField title={Translations.ObserverAction} required={state.eventSetting.observerActionIsRequired()}>
                                                <TextField name="observerAction" title={Translations.ObserverAction} inputProps={{ maxLength: 10000 }} multiline minRows={5} value={state.observerAction} onChange={this.handleChange} />
                                            </FormField>
                                        </Grid>
                                    </GridRow>
                                }
                            </>
                        }
                        {state.page === NewEventDialogPage.EventType &&
                            <>
                                <GridRow>
                                    <Grid item xs>
                                        <FormSectionTitle margin={0}>{Translations.SelectEventType + " (" + Translations.Voluntary.toLocaleLowerCase() + ")"}</FormSectionTitle>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item xs>
                                        <FormField title="" margin={0}>
                                            <TreeCheckBoxDropdownItems
                                                selectedIds={state.eventTypeIds}
                                                toggleAllId={""}
                                                values={state.eventTypeNodes}
                                                onChange={this.handleChangeEventTypeIds}
                                            />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                            </>
                        }
                        {state.page === NewEventDialogPage.EventTypeB &&
                            <>
                                <GridRow>
                                    <Grid item xs>
                                        <FormSectionTitle margin={0}>{Translations.SelectEventTypeB + " (" + Translations.Voluntary.toLocaleLowerCase() + ")"}</FormSectionTitle>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item xs>
                                        <FormField title="" margin={0}>
                                            <TreeCheckBoxDropdownItems
                                                selectedIds={state.eventTypeBIds}
                                                toggleAllId={""}
                                                values={state.eventTypeBNodes}
                                                onChange={this.handleChangeEventTypeBIds}
                                            />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                            </>
                        }
                        {state.page === NewEventDialogPage.EventTypeC &&
                            <>
                                <GridRow>
                                    <Grid item xs>
                                        <FormSectionTitle margin={0}>{Translations.SelectEventTypeC + " (" + Translations.Voluntary.toLocaleLowerCase() + ")"}</FormSectionTitle>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item xs>
                                        <FormField title="" margin={0}>
                                            <TreeCheckBoxDropdownItems
                                                selectedIds={state.eventTypeCIds}
                                                toggleAllId={""}
                                                values={state.eventTypeCNodes}
                                                onChange={this.handleChangeEventTypeCIds}
                                            />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                            </>
                        }
                    </>
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.Previous, variant: "outlined", onClick: state.page === NewEventDialogPage.Receiver ? null : this.handleMoveToPreviousPage },
                    { title: Translations.Next, variant: "confirmation", onClick: !state.pageIsLastPage ? this.handleMoveToNextPage : this.handleSave },
                ]}
                onClose={this.handleCancel}/>
        );
    }
}